export var CreditTransactionType;
(function (CreditTransactionType) {
    CreditTransactionType["Grant"] = "Grant";
    CreditTransactionType["Consume"] = "Consume";
    CreditTransactionType["TopUp"] = "TopUp";
    CreditTransactionType["Expire"] = "Expire";
    CreditTransactionType["Refund"] = "Refund";
})(CreditTransactionType || (CreditTransactionType = {}));
//# sourceMappingURL=credit-transaction-type.const.js.map